"use client";

import { useSyncExternalStore } from "react";

const QUERY = "(prefers-color-scheme: dark)";

function subscribe(cb: () => void): () => void {
  const mq = window.matchMedia(QUERY);
  mq.addEventListener("change", cb);
  return () => mq.removeEventListener("change", cb);
}

function getSnapshot(): boolean {
  return window.matchMedia(QUERY).matches;
}

function getServerSnapshot(): boolean {
  return false;
}

/**
 * Reactive read of `prefers-color-scheme: dark`. SSR-safe — returns
 * `false` on the server, then snaps to the actual preference on first
 * client render via useSyncExternalStore (no useEffect lag, no layout
 * shift). Subscribes to media-query changes so the value flips when the
 * OS theme is toggled at runtime.
 *
 * Use only inside Client Components — the hook reads `window`.
 */
export function usePrefersDark(): boolean {
  return useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
}
